import { InViewport } from '../in-viewport';
import { Loading, type LoadingProperties } from '../loading';

const InfinityLoading = ({
  className,
  hasMoreData,
  isLoading,
  onEnter,
  spinnerSize,
}: {
  className?: string;
  hasMoreData?: boolean;
  isLoading: boolean;
  onEnter: () => unknown;
  spinnerSize?: LoadingProperties['size'];
}) => {
  if (isLoading || hasMoreData) {
    return (
      <>
        {hasMoreData && !isLoading ? <InViewport onEnter={onEnter} /> : null}
        <Loading className={className} size={spinnerSize} />
      </>
    );
  }

  return null;
};

export default InfinityLoading;
